/**
 * Forms Types
 *
 * Component-specific types for dynamic forms
 */

import type { FileResult } from '@sunrise-ui/primitives';

// Re-export form field types from api-client (the translation layer)
export type {
  FormFieldRenderConfig,
  SimpleFieldOption,
} from '@sunrise-ui/api-client';

/**
 * Field state for conditional logic
 */
export type FieldState = {
  visible: boolean;
  required: boolean;
  disabled: boolean;
};

/**
 * Form values record
 */
export type FormValues = Record<string, unknown>;

/**
 * Form errors record
 */
export type FormErrors = Record<string, string>;

/**
 * Field value types
 */
export type FieldValue =
  | string
  | string[]
  | number
  | boolean
  | Date
  | File
  | FileResult
  | null
  | undefined;
